import React from 'react';
import classNames from 'classnames';
import { DatePicker as AntdDatePicker } from 'antd';
import { DatePickerProps } from 'antd/lib/date-picker';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { CalendarIcon } from 'components/Icons/Calendar';
import cn from './styles.module.scss';

export type DatepickerProps = {
  error?: React.ReactNode;
  label?: string;
} & DatePickerProps;

export const Datepicker = ({ error, label, ...props }: DatepickerProps) => (
  <div className={cn.container}>
    {label && (
      <label htmlFor={props.name} className={cn.label}>{label}</label>
    )}
    <AntdDatePicker
      className={classNames(cn.datePicker, { [cn.error]: !!error })}
      suffixIcon={<CalendarIcon />}
      {...props}
    />
    {!!error && (
      <div className={cn.errorContainer}>
        <ExclamationCircleFilled className={cn.icon} />
        {error}
      </div>
    )}
  </div>
);
